import {
    OPEN_BLOCK,
    CLOSE_BLOCK,
    TOGGLE_BLOCK,
    LOAD_BLOCK_DATA,
    BLOCK_DATA_START_LOADING,
    BLOCK_DATA_REQUEST,
    BLOCK_DATA_LOADED,
    BLOCK_DATA_LOAD_FAILED,
    BLOCK_DATA_TRANSFORMED,
    SAVE_CUSTOM_BLOCK_DATA,
    BLOCK_DATA_EMPTY,
    SAVE_IS_SCROLLED,
} from './constants'

export function openBlock(module, id, blockKey) {
    return {
        type: OPEN_BLOCK,
        data: {
            module,
            id,
            blockKey,
        },
    }
}

export function closeBlock(module, id, blockKey) {
    return {
        type: CLOSE_BLOCK,
        data: {
            module,
            id,
            blockKey,
        },
    }
}

export function toggleBlock(module, id, blockKey) {
    return {
        type: TOGGLE_BLOCK,
        data: {
            module,
            id,
            blockKey,
        },
    }
}

export function loadBlockData(module, id, blockKey, level) {
    return {
        type: LOAD_BLOCK_DATA,
        data: {
            module,
            id,
            blockKey,
            level,
        },
    }
}

export function loadBlockDataRequest(module, id, blockKey, namespace, locale, payload) {
    // create unique request by module name and entity/group id and block key and namespace (index)
    return {
        type: BLOCK_DATA_REQUEST(module, id, blockKey, namespace),
        data: {
            module,
            id,
            blockKey,
            locale,
        },
        payload,
    }
}

export function blockDataStartLoading(module, id, blockKey) {
    return {
        type: BLOCK_DATA_START_LOADING,
        data: {
            module,
            id,
            blockKey,
        },
    }
}

export function blockDataLoaded(module, id, blockKey, locale, data, level) {
    return {
        type: BLOCK_DATA_LOADED,
        data: {
            module,
            id,
            blockKey,
            locale,
            data,
            level,
        },
    }
}

export function blockDataEmpty(module, id, blockKey) {
    return {
        type: BLOCK_DATA_EMPTY,
        data: {
            module,
            id,
            blockKey,
        },
    }
}

export function blockDataLoadFailed(module, id, blockKey, errorCodes) {
    return {
        type: BLOCK_DATA_LOAD_FAILED,
        data: {
            module,
            id,
            blockKey,
            errorCodes,
        },
    }
}

export function blockDataTransformed(module, id, blockKey, transformedData) {
    return {
        type: BLOCK_DATA_TRANSFORMED,
        data: {
            module,
            id,
            blockKey,
            transformedData,
        },
    }
}

export function blockSaveCustomData(module, id, blockKey, customData) {
    return {
        type: SAVE_CUSTOM_BLOCK_DATA,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function setIsScrolled(data) {
    return {
        type: SAVE_IS_SCROLLED,
        data,
    }
}
